'use client';

import { smallVariants, largeVariants } from "./constants.js";
const getIconSize = ({
  variant
}) => {
  if (variant) {
    if (smallVariants.includes(variant)) return "sm";
    if (largeVariants.includes(variant)) return "lg";
    return "md";
  }
  return "md";
};
export {
  getIconSize
};
